export const getParams = name => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.slice(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};

export const isFBAndroid =
  /FB/.test(navigator.userAgent) && /Android/.test(navigator.userAgent);
export const isFB =
  /FB/.test(navigator.userAgent);
export const isIOS = window.platform.isIOS() || window.platform.isIpad();

export const getCurDate = () => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth() + 1;
  const day = now.getUTCDate();
  const formattedDate = `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;
  return month !== 6 ? '2023/06/01' : formattedDate;
};
export const throttle = (fun, delay) => {
  let last, deferTimer;
  return function (args) {
      let that = this
      let _args = arguments
      let now = +new Date()
      if (last && now < last + delay) {
          clearTimeout(deferTimer)
          deferTimer = setTimeout(function () {
              last = now
              fun.apply(that, _args)
          }, delay)
      }else {
          last = now
          fun.apply(that,_args)
      }
  }
};